import React, { useCallback, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { courtStyles as styles } from "./court.tailwind";
import { getAllPurchasedOrMyCartTokens } from "../../../../redux/slices/sportSlice";
import CourtsWrapper from "./CourtsWrapper";
import OverlayLoader from "../../../shared/Loaders/OverlayLoader/OverlayLoader";

const Court = ({ showHoveredTooltip = false, currentCommentary, showZoneOnMobileScreen, previewGame = false, courtOuterSvgId="svg-holder", tokensToShowOnGround, isDeployTokenPage = false, makeSelectable = false, selectedZones=[], zonesToBeHighlighted=[], selectZone, getTokens, isScorerPage=false, hideZoneName, isLiveGame, teamDetails, purchasedTokens=[], hideHover = false, disableTokenHover }) => {
  const apiRef = useRef(false);
  const { sportsSeasonId } = useParams();
  const { currentSeason } = useSelector(state => state.seasons);
  const { allTokensLoading } = useSelector(state => state.sport);
  const { savingToCart, removingTokenFromCart } = useSelector(state => state.cart);

  // fetch tokens
  const callApi = useCallback(async () => {
    // data to pass
    const data = {
      seasonId: sportsSeasonId, // season id
    };

    await getTokens(data); // all tokens data
  }, [sportsSeasonId, currentSeason]);

  useEffect(() => {
    if(apiRef.current || previewGame) return;
      apiRef.current = true;

    callApi();
  }, [callApi, previewGame]);

  // console.log("makeSelectable: ", makeSelectable);

  return (
    <div className={`${styles.container} ${previewGame ? "p-2 rounded-[10px] " : "pb-4"} ${isDeployTokenPage ? styles.deployTokenPage : ''} ${isScorerPage ? styles.ScorerTokenPage : ''}`} style={{ scrollbarWidth: "none" }} id="thisCourtPage">
      {(allTokensLoading || savingToCart || removingTokenFromCart) && <OverlayLoader />}
      
      {/* Main Court Ground */}
      <CourtsWrapper
        courtOuterSvgId={courtOuterSvgId}
        showHoveredTooltip={showHoveredTooltip}
        tokensToShowOnGround={tokensToShowOnGround}
        previewGame={previewGame}
        makeSelectable={makeSelectable}
        zonesToBeHighlighted={zonesToBeHighlighted}
        selectedZones={selectedZones}
        selectZone={selectZone}
        isDeployTokenPage={isDeployTokenPage}
        isScorerPage={isScorerPage}
        hideZoneName={hideZoneName}
        isLiveGame={isLiveGame}
        teamDetails={teamDetails}
        purchasedTokens={purchasedTokens}
        hideHover={hideHover}
        disableTokenHover={disableTokenHover}
        showZoneOnMobileScreen={showZoneOnMobileScreen}
        currentCommentary={currentCommentary}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getTokens: (data) => dispatch(getAllPurchasedOrMyCartTokens(data)),
});

export default connect(null, mapDispatchToProps)(React.memo(Court));